module.exports = __webpack_public_path__ + "files/8681ff9c9703d8fe884a4211393b5602.png";